import { ReactNode } from 'react';
import { Module } from '@modules/admin/types';
import LoginPage from '@modules/auth/pages/Login';
import Dashboard from '@modules/dashboard/pages/Dashboard';
import { Checklist, Dashboard as DashboardIcon, HourglassEmptyOutlined, Campaign } from '@mui/icons-material';
import { offerRoutes } from '@modules/offers/routes';
import { playbookRoutes } from '@modules/playbook/routes';
import { adminRoutes } from '@modules/admin/routes';
// import { tmcRoutes } from '@modules/tmc/routes';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';

export interface BaseRoute {
  path: string;
  component: React.ComponentType;
  title?: string;
  showInSidebar?: boolean;
  icon?: ReactNode;
  sidebarText?: string;
  // Permission requirements
  module?: Module; // Which module this route belongs to
  requiresView?: boolean; // Requires view permission (default: true if module is set)
  requiresAdd?: boolean; // Requires add permission
  requiresUpdate?: boolean; // Requires update permission
  isPublic?: boolean; // Public routes that don't require any permissions (like profile, dashboard)
}

// Public routes (no authentication required)
export const publicRoutes: BaseRoute[] = [
  {
    path: '/login',
    component: LoginPage,
    title: 'Login',
  },
];

// Protected routes (authentication required)
export const protectedRoutes: BaseRoute[] = [
  {
    path: '/',
    component: Dashboard,
    title: 'Dashboard',
    showInSidebar: true,
    icon: <DashboardIcon />,
    sidebarText: 'Dashboard',
    module: Module.DASHBOARD,
    requiresView: true,
  },
  ...offerRoutes,
  {
    path: '/ab-testing',
    component: () => (
      <Box
        sx={{
          textAlign: 'center',
          mt: 10,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: 90,
            height: 90,
            borderRadius: '50%',
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 2,
          }}
        >
          <HourglassEmptyOutlined sx={{ fontSize: 50 }} />
        </Box>

        <Typography variant="h4">Coming Soon...</Typography>
      </Box>
    ),
    title: 'AB Testing',
    showInSidebar: true,
    icon: <Checklist />,
    sidebarText: 'AB Testing',
    module: Module.AB_TESTING,
    requiresView: true,
  },
  // ...tmcRoutes,
  {
    path: '/tmc',
    component: () => (
      <Box
        sx={{
          textAlign: 'center',
          mt: 10,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: 90,
            height: 90,
            borderRadius: '50%',
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 2,
          }}
        >
          <HourglassEmptyOutlined sx={{ fontSize: 50 }} />
        </Box>

        <Typography variant="h4">Coming Soon...</Typography>
      </Box>
    ),
    title: 'TMC Campaigns',
    showInSidebar: true,
    icon: <Campaign />,
    sidebarText: 'TMC Campaigns',
    module: Module.TMC,
    requiresView: true,
  },
  ...playbookRoutes,
  ...adminRoutes,
];
